export const CONTACT_EMAIL = "creatorintelligencetube@gmail.com";
export const MAILTO = `mailto:${CONTACT_EMAIL}`;

/**
 * Build a mailto: URL pre-filled with the current form values. This lets the
 * visitor's own email client (Gmail webmail, Outlook, Apple Mail) send the
 * message directly to the site owner's inbox without waiting for a backend
 * email service.
 */
export function buildMailtoUrl({ name = "", email = "", subject = "", message = "" } = {}) {
  const encodedSubject = encodeURIComponent(subject ? `[Contact] ${subject}` : "[Contact] New message");
  const bodyParts = [
    `Name: ${name}`,
    `From: ${email}`,
    "",
    message || "",
    "",
    "---",
    "Sent via the Creator Intelligence Tube contact form",
  ];
  const encodedBody = encodeURIComponent(bodyParts.join("\n"));
  return `${MAILTO}?subject=${encodedSubject}&body=${encodedBody}`;
}

/**
 * Build a Gmail compose URL. Opens Gmail's web composer with fields pre-filled
 * — works for anyone logged into Gmail in their browser, even if `mailto:` is
 * not the system default handler.
 */
export function buildGmailComposeUrl({ subject = "", message = "", name = "", email = "" } = {}) {
  const params = new URLSearchParams({
    view: "cm",
    fs: "1",
    to: CONTACT_EMAIL,
    su: subject ? `[Contact] ${subject}` : "[Contact] New message",
    body: [
      `Name: ${name}`,
      `From: ${email}`,
      "",
      message || "",
    ].join("\n"),
  });
  return `https://mail.google.com/mail/?${params.toString()}`;
}
